// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore lodash is in the parent dir
import _ from 'lodash';

import { toast } from 'hooks/useToaster';
import { submitQuoteToTMS } from 'lib/api/submitQuoteToTMS';

import { ProcessQuoteTMSSubmissionProps } from '../types';
import {
  parseLocation,
  validateStopsAllowQuoteLocationFormats,
} from '../utils';

/**
 * Processes quote submission to TMS
 * TODO: Refactor for multi-stop ENG-4013
 */
export async function processQuoteTMSSubmission({
  customerId,
  finalPrice,
  getValues,
  setError,
}: ProcessQuoteTMSSubmissionProps) {
  const formValues = getValues();
  if (formValues.stops.length > 2) {
    toast({
      description: 'Multi-stop loads are not yet supported for TMS submission.',
      variant: 'destructive',
    });
    return;
  }

  const validationErrors = validateStopsAllowQuoteLocationFormats(
    formValues,
    setError
  );
  if (validationErrors.length > 0) {
    toast({
      description: 'Unable to submit quote to TMS due to invalid location(s).',
      variant: 'destructive',
    });
    return;
  }

  const pickup = parseLocation(formValues.stops[0].location || '');
  const delivery = parseLocation(
    formValues.stops[formValues.stops.length - 1].location || ''
  );

  const res = await submitQuoteToTMS({
    customerId: customerId.toString(),
    quotePrice: _.round(finalPrice ?? 0),
    transportType: getValues('transportType'),
    pickupLocationZip: pickup!.zip,
    pickupLocationCity: pickup!.city,
    pickupLocationState: pickup!.state,
    pickupDate: new Date(getValues('pickupDate'))?.toISOString() ?? '',
    deliveryLocationZip: delivery!.zip,
    deliveryLocationCity: delivery!.city,
    deliveryLocationState: delivery!.state,
    deliveryDate: new Date(getValues('deliveryDate'))?.toISOString() ?? '',
  });

  if (res.isOk()) {
    return res.value;
  } else {
    toast({
      description: 'Error creating Quote in TMS.',
      variant: 'destructive',
    });

    return;
  }
}
